import owd from 'owd/owd';

export default class PageIn extends owd.Component {
	init() {
		this.addClass();
		this.bind();
	}

	addClass() {
		this.$element.addClass('is-visible');
	}

	bind() {
		this.on('ajaxload', this.dom.$window, (e) => {
            this.$element.addClass('is-visible');
        });
	}
}

owd.registerComponent('page-in', {
	component: PageIn
});
